export class Empresa {

  cif: string;
  codpostal: number;
  direccion: string;
  email: string;
  id_actividadempresarial: number;
  id_cnae: number;
  id_empresa: number;
  id_interlocutorinicie: number;
  id_municipio: number;
  id_provincia: number;
  id_subcnae: number;
  nfiscal: string;
  representante: string;
  representantedni: string;
  telefono: string;
  logo: string;
  foto: string;
  interlocutor: string;
  interlocutoremail: string;
  interlocutortelefono: string;

  constructor(){
    this.cif = "";
    this.codpostal = 0;
    this.direccion = "";
    this.email = "";
    this.id_actividadempresarial = 0;
    this.id_cnae = 0;
    this.id_empresa = 0;
    this.id_interlocutorinicie = 0;
    this.id_municipio = 0;
    this.id_provincia = 0;
    this.id_subcnae = 0;
    this.nfiscal = "";
    this.representante = "";
    this.representantedni = "";
    this.telefono = "";
    this.logo = "";
    this.foto = "";
    this.interlocutor = "";
    this.interlocutoremail = "";
    this.interlocutortelefono = "";

  }

}



// WEBPACK FOOTER //
// ./src/app/_models/empresa.model.ts